export const environment = {
  production: false,
  enable_test_ui: false,
  base_url: 'https://testapi.payarc.net/v1',
  googleAnalyticsId: ''
};
